import { get, del, post } from 'services/client'
import { PAGE_LIMIT } from './constants'

export const fetchInvitations = ({
  page = 1,
  keyword = '',
  limit = PAGE_LIMIT,
  filters,
}) =>
  get(
    `procurements/invitations?page=${page}&limit=${limit}${
      keyword ? `&search=${keyword}` : ''
    }${
      filters && filters.hasOwnProperty('homologated')
        ? `&homologated=${filters.homologated}`
        : ''
    }`,
  )

export const removeInvitations = ids =>
  del('procurements/invitations', { identities: ids })

export const resendInvitation = ({ id, email }) =>
  post(`procurements/invitations/${id}/resend`, { email: email })
